<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-full px-4">
      <div
        style="min-height: calc(100vh - 176px)"
        class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
      >
        <div
          style="max-height: 100%; overflow: hidden"
          class="mt-5 relative overflow-x-auto shadow-md sm:rounded-lg"
        >

          <div class="table-container inl-100 tsor-table">
            <div class="table-row header">
              <!-- <div class="row-item inl-20 bt-n bb-n br-r">
                <span class="px-6 py-2">ИИН</span>
              </div> -->
              <div class="row-item inl-20 bt-n bb-n br-r">
                <span class="px-6 py-2">ФИО</span>
              </div>
              <!-- <div class="row-item inl-20 bt-n bb-n br-r">
                <span class="px-6 py-2">В/Ч</span>
              </div> -->
              <div class="row-item inl-20 bt-n bb-n br-r">
                <span class="px-6 py-2">Курс</span>
              </div>
              <div class="row-item inl-20 bt-n bb-n br-r">
                <span class="px-6 py-2">Оценка</span>
              </div>
            </div>

            <div v-for="(el, ind) in courses" :key="ind" class="table-row body">
              <!-- <div class="row-item inl-20">
                <span class="px-6 py-2">{{ el.student.iin }}</span>
              </div> -->
              <div class="row-item inl-20">
                <span class="px-6 py-2">{{ el.student.fio }}</span>
              </div>
              <!-- <div class="row-item inl-20">
                <span class="px-6 py-2">{{ el.group }}</span>
              </div> -->
              <div class="row-item inl-20">
                <span class="px-6 py-2">{{ el.course }}</span>
              </div>
              <div class="row-item inl-20">

                <div v-if="el.estimate" class="flex-center inl-100">
                  <span class="pl-3 inl-20">{{ el.estimate }}</span>
                  <span class="px-6 py-2 inl-70">
                    <router-link
                      :to="'/client/certificate/' + el.student.id  + '/' + el.course_uuid"
                      v-slot="{ href, navigate }"
                    >
                        <button
                            :href="href"
                            @click="navigate"
                            class='inl-100 px-2 py-1 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150'
                            type="button">
                            <span
                            >сертификат</span>
                        </button>
                    </router-link>
                  </span>
                </div>
                <span v-else class="px-6 py-2">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_CLIENT, HEADERS_TOKEN_JSON } from "@/const/uri";

export default {
  data() {
    return {
      courses: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    changeData(index, data) {
      this.courses[index].status = data;
    },
    async loadData() {
      await axios({
        method: "GET",
        url: API_CLIENT.adminEstimates,
        headers: HEADERS_TOKEN_JSON(),
      })
        .then((e) => {
          const data = e.data.data;
          this.courses = data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>